var overlay = {
	page: $('.page-products'),
	elem: $('.product'),
	overlayEl: $('.product-overlay'),
	triggerOpen: $('.product-overlay-open'),
	triggerClose: $('.product-overlay-close'),

	forceClose: function() {
		$(overlay.page).find('.active').removeClass('active');
		$(overlay.page).find('.overlay-open').removeClass('overlay-open');
	},

	toggleOverlay: function() {

		// Setup Trigger Elements
		var triggerEls = overlay.triggerOpen.add( overlay.triggerClose );
		triggerEls.each( function( index, element ) {
			overlay.setupTrigger( $( this ) );
		} );

		// Add Event Listener tp Document
		$(document).click( function(event) {

			if(!$(event.target).closest(overlay.triggerOpen).length && !$(event.target).closest(overlay.overlayEl).length) {
		        overlay.forceClose();
		    }
		} );

	},

	add: function( el ) {
		console.log( "overlay: add" );

		overlay.elem = overlay.elem.add( el );
		overlay.overlayEl = overlay.overlayEl.add( el.find( '.product-overlay' ) );

		el.find( '.product-overlay-open' ).each( function() {
			overlay.addTriggerOpenEl( $( this ) );
		} );

		el.find( '.product-overlay-close' ).each( function() {
			overlay.addTriggerCloseEl( $( this ) );
		} );

	},

	addTriggerOpenEl: function( el ) {
		//console.log( "overlay: addTriggerOpenEl", el );

		overlay.triggerOpen = overlay.triggerOpen.add( el );
		overlay.setupTrigger( el );

	},

	addTriggerCloseEl: function( el ) {
		//console.log( "overlay: addTriggerCloseEl", el );

		overlay.triggerClose = overlay.triggerClose.add( el );
		overlay.setupTrigger( el );

	},

	setupTrigger: function( el ) {
		//console.log( "overlay: setupTrigger", el );

		el.on( 'click', function(e) {
			console.log( "overlay: onTriggerClick" );

			e.preventDefault();

			overlay.forceClose();
			var $this = $(this);
			$this.closest(overlay.elem).find(overlay.overlayEl).toggleClass('active');
			$this.closest(overlay.elem).toggleClass('overlay-open');


			// Close any zoom overlayz if open
			zoom.zoomedEl.removeClass('zoom-open'); // zoom.js


			// Home - Hero's product carousel - Hide arrows
			function hideShow_sliderArrows() {
				$this.closest('.slide-content-products').find('.slick-arrow').each(function(){
					$(this).fadeToggle();
				});
			}
			if ($this.closest('.slide-content-products').length) {
				if ($this.hasClass('product-overlay-open')) {
					hideShow_sliderArrows();
				} else {
					setTimeout(function(){
						hideShow_sliderArrows();
					}, 200);
				}
			}
		} );

	},

	init: function() {
		if (overlay.overlayEl.length > 0) {
			overlay.toggleOverlay();
		}
	}
};